import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const EmployeeTimingLeaveForm = () => {
  const navigate = useNavigate();
  const [timingData, setTimingData] = useState({
    employee_id: "",
    period_from: "",
    period_to: "",
    shift_start: "",
    shift_end: "",
    created_by: "",
  });

  const [dayOffData, setDayOffData] = useState({
    employee_id: "",
    day: "",
    category: "",
    created_by: "",
  });

  const [leaveData, setLeaveData] = useState({
    employee_id: "",
    period_from: "",
    period_to: "",
    total_leave: "",
    created_by: "",
  });

  const [loading, setLoading] = useState(false);

  // Generic input handler
  const handleChange = (e, section) => {
    const { name, value } = e.target;
    if (section === "timing") setTimingData((prev) => ({ ...prev, [name]: value }));
    else if (section === "dayoff") setDayOffData((prev) => ({ ...prev, [name]: value }));
    else if (section === "leave") setLeaveData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit handlers
  const handleSubmitTiming = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { 
        ...timingData, 
        employee_id: Number(timingData.employee_id), 
        created_by: Number(timingData.created_by) 
      };
      const response = await axios.post(
        "employees/timing/add-timing",
        payload
      );
      alert("Employee timing saved successfully!");
      console.log(response.data);
      navigate("/dashboard/employees/list");
    } catch (error) {
      console.error(error.response?.data || error);
      alert("Error saving timing: " + JSON.stringify(error.response?.data));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitDayOff = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { 
        ...dayOffData, 
        employee_id: Number(dayOffData.employee_id), 
        created_by: Number(dayOffData.created_by) 
      };
      const response = await axios.post(
        "employees/timing/add-dayoff",
        payload
      );
      alert("Employee day off saved successfully!");
      console.log(response.data);
      navigate("/dashboard/employees/list");
    } catch (error) {
      console.error(error.response?.data || error);
      alert("Error saving day off: " + JSON.stringify(error.response?.data));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitLeave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { 
        ...leaveData, 
        employee_id: Number(leaveData.employee_id), 
        total_leave: Number(leaveData.total_leave), 
        created_by: Number(leaveData.created_by) 
      };
      const response = await axios.post(
        "employees/timing/add-leave",
        payload
      );
      alert("Employee leave saved successfully!");
      console.log(response.data);
      navigate("/dashboard/employees/list");
    } catch (error) {
  console.error(error.response?.data);
  alert(JSON.stringify(error.response?.data, null, 2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-end mb-4">
        <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>
      {/* Employee Timing Form */}
      <div className="card shadow p-4 mb-4">
        <h3>Employee Timing</h3>
        <form onSubmit={handleSubmitTiming}>
          <div className="row">
            <div className="col-md-4">
              <label>Employee ID</label>
              <input type="number" name="employee_id" value={timingData.employee_id} onChange={(e) => handleChange(e, "timing")} className="form-control" required />
            </div>
            <div className="col-md-4">
              <label>Period From</label>
              <input type="date" name="period_from" value={timingData.period_from} onChange={(e) => handleChange(e, "timing")} className="form-control" required />
            </div>
            <div className="col-md-4">
              <label>Period To</label>
              <input type="date" name="period_to" value={timingData.period_to} onChange={(e) => handleChange(e, "timing")} className="form-control" required />
            </div>
            <div className="col-md-4 mt-3">
              <label>Shift Start</label>
              <input type="time" name="shift_start" value={timingData.shift_start} onChange={(e) => handleChange(e, "timing")} className="form-control" required />
            </div>
            <div className="col-md-4 mt-3">
              <label>Shift End</label>
              <input type="time" name="shift_end" value={timingData.shift_end} onChange={(e) => handleChange(e, "timing")} className="form-control" required />
            </div>
            <div className="col-md-4 mt-3">
              <label>Created By (ID)</label>
              <input type="number" name="created_by" value={timingData.created_by} onChange={(e) => handleChange(e, "timing")} className="form-control" required />
            </div>
          </div>
          <button type="submit" className="btn btn-primary mt-3" disabled={loading}>{loading ? "Saving..." : "Save Timing"}</button>
        </form>
      </div>

      {/* Employee Day Off Form */}
      <div className="card shadow p-4 mb-4">
        <h3>Employee Day Off</h3>
        <form onSubmit={handleSubmitDayOff}>
          <div className="row">
            <div className="col-md-4">
              <label>Employee ID</label>
              <input type="number" name="employee_id" value={dayOffData.employee_id} onChange={(e) => handleChange(e, "dayoff")} className="form-control" required />
            </div>
            <div className="col-md-4">
              <label>Day</label>
              <input type="date" name="day" value={dayOffData.day} onChange={(e) => handleChange(e, "dayoff")} className="form-control" required />
            </div>
            <div className="col-md-4">
              <label>Category</label>
              <input type="text" name="category" value={dayOffData.category} onChange={(e) => handleChange(e, "dayoff")} className="form-control" required />
            </div>
            <div className="col-md-4 mt-3">
              <label>Created By (ID)</label>
              <input type="number" name="created_by" value={dayOffData.created_by} onChange={(e) => handleChange(e, "dayoff")} className="form-control" required />
            </div>
          </div>
          <button type="submit" className="btn btn-primary mt-3" disabled={loading}>{loading ? "Saving..." : "Save Day Off"}</button>
        </form>
      </div>

      {/* Employee Leave Form */}
      <div className="card shadow p-4 mb-4">
        <h3>Employee Leave</h3>
        <form onSubmit={handleSubmitLeave}>
          <div className="row">
            <div className="col-md-4">
              <label>Employee ID</label>
              <input type="number" name="employee_id" value={leaveData.employee_id} onChange={(e) => handleChange(e, "leave")} className="form-control" required />
            </div>
            <div className="col-md-4">
              <label>Period From</label>
              <input type="date" name="period_from" value={leaveData.period_from} onChange={(e) => handleChange(e, "leave")} className="form-control" required />
            </div>
            <div className="col-md-4">
              <label>Period To</label>
              <input type="date" name="period_to" value={leaveData.period_to} onChange={(e) => handleChange(e, "leave")} className="form-control" required />
            </div>
            <div className="col-md-4 mt-3">
              <label>Total Leave (days)</label>
              <input type="number" name="total_leave" value={leaveData.total_leave} onChange={(e) => handleChange(e, "leave")} className="form-control" required />
            </div>
            <div className="col-md-4 mt-3">
              <label>Created By (ID)</label>
              <input type="number" name="created_by" value={leaveData.created_by} onChange={(e) => handleChange(e, "leave")} className="form-control" required />
            </div>
          </div>
          <button type="submit" className="btn btn-primary mt-3" disabled={loading}>{loading ? "Saving..." : "Save Leave"}</button>
        </form>
      </div>
    </div>
  );
};

export default EmployeeTimingLeaveForm;
